module.exports = __webpack_public_path__ + "static/img/yousousuo.ae02af9f.svg";